import BarangayField from "./BarangayField"

export default BarangayField
